import React, { useState, useEffect, useCallback } from 'react';
import "../styles/steps.css";

const BudgetHours = ({ formData, updateFormData, setStepValidation, stepNumber }) => {
    const [error, setError] = useState('');

    const validateFields = useCallback((nextClicked = false) => {
        let errorMessage = '';
        if (nextClicked) {
            if (!formData.budget || formData.budget <= 0) {
                errorMessage = 'Budget must be greater than zero.';
            } else if (!formData.estimatedHours || formData.estimatedHours <= 0) {
                errorMessage = 'Estimated hours must be greater than zero.';
            }
        }

        setError(errorMessage);
        return errorMessage === ''; // Return true if valid, false if not
    }, [formData.budget, formData.estimatedHours]);

    useEffect(() => {
        if (setStepValidation) {
            setStepValidation(stepNumber, validateFields);
        }
    }, [setStepValidation, stepNumber, validateFields]); // Only include stable dependencies

    const handleChange = (e) => {
        const { name, value } = e.target;
        updateFormData({ [name]: value });

        // Clear error when user types
        if (error) {
            validateFields();
        }
    };

    return (
        <div className="step-container">
            <p className="step-description">
            Time to make your best guesstimate! 🧐 Enter a rough idea of your project’s budget and total hours. It doesn’t have to be perfect—Soft Estimate will do the heavy lifting and fine-tune the details. Just drop in any number to get started!
            </p>
            <br></br>
            <div className="input-group-inOneRow">
                <label className="input-label">Budget ($):</label>
                <input
                    className="input-number-field"
                    type="number"
                    name="budget"
                    placeholder="Budget"
                    value={formData.budget}
                    onChange={handleChange}
                    required
                />
                <label className="input-label">Guesstimate Hours:</label>
                <input
                    className="input-number-field"
                    type="number"
                    name="estimatedHours"
                    placeholder="Guesstimate Hours"
                    value={formData.estimatedHours}
                    onChange={handleChange}
                    required
                />
            </div>

            {/* Show error message inside the step if validation fails */}
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default BudgetHours;